import { Alert, Dialog } from '@mui/material'
import { useCreateWorkspace } from '@/hooks/useCreateWorkspace'
import { createWorkspaceErrorMessage } from '@/hooks/createWorkspaceErrorMessage'
import CreateWorkspaceFormBody from '@/pages/CreateWorkspace/CreateWorkspaceFormBody.jsx'
import dialogStyles from './CreateWorkspaceDialog.module.scss'

function CreateWorkspaceDialogBody({ onClose }) {
  const { form, submit, onSubmit } = useCreateWorkspace({
    switchOnSuccess: true,
    onCreated: () => onClose(),
  })
  const errorMessage =
    form.submitError || (submit.isError ? createWorkspaceErrorMessage(submit.error) : '')
  return (
    <form className={dialogStyles.form} onSubmit={onSubmit}>
      {errorMessage ? <Alert severity="error">{errorMessage}</Alert> : null}
      <CreateWorkspaceFormBody
        form={form}
        submitLabel={submit.isPending ? 'Creating…' : 'Create workspace'}
        showHeading
      />
    </form>
  )
}

export default function CreateWorkspaceDialog({ open, onClose }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      aria-labelledby="add-workspace-title"
      slotProps={{
        paper: {
          className: dialogStyles.paper,
          elevation: 24,
          sx: { padding: '32px' },
        },
      }}
    >
      {open ? <CreateWorkspaceDialogBody onClose={onClose} /> : null}
    </Dialog>
  )
}
